import $ from 'jquery';

$(document).ready(function() {
    if ($(window).width() < 1024) {
        $('.js-info-slider').slick({
            dots: false,
            slidesToShow: 1.1,
            slidesToScroll: 1,
            arrows: false,
            infinite: false
        });
    }
});


// WEBPACK FOOTER //
// ./src/js/pages/main/info-slider.js